import hexRgb from 'hex-rgb';
import colorObjToString from './colorObjToString';

export function hexToColorString({
  hex,
  alpha = 1,
}: { hex: string; alpha?: number }) {
  const { red: r, green: g, blue: b } = hexRgb(hex);
  return colorObjToString({ r, g, b, a: alpha });
}
